module.exports = __webpack_public_path__ + "img/prize-05-pic.0bbdef4e.png";